import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';
import { Root, createRoot } from 'react-dom/client';
import { ViewGuest } from '../../../patient/src/views/view_guest/mod';
import { Route, Routes } from 'react-router';
import { sharedResolution } from '@public/src/shared_resolution';
import { LocationSelectorService } from '@public/src/application/services/location_selector.service';
import { useEffect } from 'react';
import { useResolve } from '@visiba/instantiation';
import { UniversalConfig } from '@application/universal_config.service';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';

const containerElementName = 'GuestComponent';
const FULL_HEIGHT_CLASS_NAME = 'js-fullHeight';
const ALTERNATIVE_BACKGROUND_CLASS_NAME = 'js-alternativeBackground';

@Component({
	standalone: false,
	selector: 'guest-component',
	template: ` <div class="wrapper-container full-height" #${containerElementName}></div> `,
	encapsulation: ViewEncapsulation.None,
	styles: [
		`
			& .full-height {
				height: 100%;
			}
		`,
	],
})
export class GuestWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(private readonly ngZone: NgZone) {
		// Empty
	}

	ngAfterViewInit() {
		document.body.classList.add(FULL_HEIGHT_CLASS_NAME);
		document.body.classList.add(ALTERNATIVE_BACKGROUND_CLASS_NAME);
		this.render();
	}

	ngOnDestroy() {
		document.body.classList.remove(FULL_HEIGHT_CLASS_NAME);
		document.body.classList.remove(ALTERNATIVE_BACKGROUND_CLASS_NAME);
		this.root?.unmount();
	}

	private async render() {
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		const universalConfigService = sharedResolution.resolve(UniversalConfig);

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const split = locationSelectorService.location.route.split('/');
		split.splice(0, 1);
		const routeBase = split.join('/');

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
						<Routes>
							<Route path={routeBase}>
								<Route path='guest-participant/:ticket' element={<ViewGuest />} />
								<Route path='*' element={<FunkyAngularRedirect />} />
							</Route>
						</Routes>
					</ProgrammaticBrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}

function FunkyAngularRedirect() {
	const universalConfig = useResolve(UniversalConfig);

	useEffect(() => {
		window.__TEMP__overrideNavigation(universalConfig.alias);
	}, [universalConfig]);

	return null;
}
